export const VERSION = {
    'version': 'f507579f-a7b0-4d70-9027-87aa5e35b020',
    'build': '01a021c9-8427-4cdd-bdd1-18ad1dda695d'
};
